import script from "./flyDeviationInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./flyDeviationInfo.vue?vue&type=script&lang=ts&setup=true"

import "./flyDeviationInfo.vue?vue&type=style&index=0&id=1051665e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/K8S-上海阿里云Prod环境-UOTS-Front/frontend/front-uots-simulator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1051665e"]])

export default __exports__